import { Form, Input, Button, Card, message, Checkbox } from "antd";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";

export default function Register() {
  const navigate = useNavigate();

  const onFinish = async (values) => {
    try {
      await api.post("/auth/register", values);
      message.success("Registration successful. Please login.");
      navigate("/login");
    } catch (err) {
      message.error(err.response?.data?.message || "Registration failed");
    }
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", marginTop: 80 }}>
      <Card title="Customer Registration" style={{ width: 420 }}>
        <Form layout="vertical" onFinish={onFinish}>

          <Form.Item
            name="name"
            label="Full Name"
            rules={[{ required: true, message: "Please enter your name" }]}
          >
            <Input placeholder="Enter your full name" />
          </Form.Item>

          <Form.Item
            name="shopName"
            label="Shop Name"
            rules={[{ required: true, message: "Please enter shop name" }]}
          >
            <Input placeholder="Enter shop name" />
          </Form.Item>

          <Form.Item
            name="shopCode"
            label="Shop Code"
          >
            <Input placeholder="Enter shop code (optional)" />
          </Form.Item>

          <Form.Item
            name="email"
            label="Email Address"
            rules={[
              { required: true, message: "Please enter email" },
              { type: "email", message: "Enter valid email" }
            ]}
          >
            <Input placeholder="Enter email address" />
          </Form.Item>

          <Form.Item
            name="contactNo"
            label="Contact Number"
            rules={[
              { required: true, message: "Please enter contact number" },
              { pattern: /^[0-9]{10}$/, message: "Enter valid 10 digit number" }
            ]}
          >
            <Input placeholder="Enter mobile number" />
          </Form.Item>

          <Form.Item
            name="password"
            label="Password"
            extra="Use at least 8 characters including letters, numbers, and special symbols"
            rules={[
              { required: true, message: "Please enter password" },
              {
                min: 8,
                message: "Password must be at least 8 characters"
              },
              {
                pattern: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&]).+$/,
                message:
                  "Password must include letters, numbers, and at least one special character"
              }
            ]}
          >
            <Input.Password placeholder="Enter strong password" />
          </Form.Item>

          <Form.Item
            name="terms"
            valuePropName="checked"
            rules={[
              {
                validator: (_, value) =>
                  value ? Promise.resolve() : Promise.reject("You must accept Terms & Conditions")
              }
            ]}
          >
            <Checkbox>
              I agree to the <a href="#">Terms & Conditions</a>
            </Checkbox>
          </Form.Item>

          <Button type="primary" htmlType="submit" block>
            Register
          </Button>

          <Button
            type="link"
            onClick={() => navigate("/login")}
            block
          >
            Already have account? Login
          </Button>

        </Form>
      </Card>
    </div>
  );
}